module.exports = __webpack_public_path__ + "static/media/DSAInstructor.23b7c422.svg";